import {
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_RESET,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const updateProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
        success: false,
        message: "",
      });

    case UPDATE_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        success: true,
        error: false,
        message: (action.payload && action.payload.message) || "Product updated successfully",
      });

    case UPDATE_PRODUCT_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
        success: false,
        message: (action.payload && action.payload.error) || "Failed to update product",
      });

    case UPDATE_PRODUCT_RESET:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};

export default updateProductReducer;
